import { RegionCreatableInterface } from '../interfaces/region-creatable.interface';
import { RegionDto } from './region.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class RegionCreateDto
  extends IntersectionType(
    PickType(RegionDto, [
      'name',
      'repairsRate',
      'specialJobsPercentage',
      'pieceworkPercentage',
    ]),
    PartialType(
      PickType(RegionDto, [
        'archived',
        'allowPayoutAmountEditing',
        'garageCostFixed',
        'dwHangingCostPerBoard',
        'dwFinishingCostPerBoard',
        'dwSprayingCostPerBoard',
        'highCeilingPerBoard',
        'screwInspectionPerBoard',
        'phaseStructureType',
        'dwpHangingCostPerBoard',
        'dwpFinishCostPerBoard',
        'dwpPrimeCostPerSqft',
        'dwpBump1CostPerBoard',
        'dwpTrim1CostPerSqft',
        'dwpInteriorPaintCostPerSqft',
        'dwpBump2CostPerBoard',
        'dwpTrim2CostPerSqft',
        'dwpFinalPaintCostPerSqft',
        'dwpBump3CostPerBoard',
        'dwpCMBluetapeCostPerSqft',
        'dwpFinalBluetapeCostPerSqft',
        'interiorOptionsPercentage',
        'exteriorOptionsPercentage',
        'trimOptionPercentage',
      ]),
    ),
  )
  implements RegionCreatableInterface {}
